import React from 'react'
import Svg, { G, Circle, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCart = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCart.dimensions.width} ${IconCart.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M17.96 19.053a2.578 2.578 0 01-2.577 2.578H3.943a2.578 2.578 0 01-2.578-2.578V3.943a2.578 2.578 0 012.578-2.578h11.44a2.578 2.578 0 012.578 2.578.683.683 0 001.365 0A3.944 3.944 0 0015.383 0H3.943A3.944 3.944 0 00.001 3.943v15.11a3.944 3.944 0 003.942 3.942h11.44a3.944 3.944 0 003.943-3.942.683.683 0 00-1.366 0z" />
        <Path d="M12.1 7.175h10.363a1.589 1.589 0 011.498 2.127l-1.13 3.13a1.595 1.595 0 01-1.498 1.049h-6.06c-.69 0-1.3-.447-1.51-1.105l-1.663-5.2zm-.437-1.364l-.36-1.126a2.948 2.948 0 00-2.81-2.055h-2.29a.683.683 0 000 1.365h2.29c.69 0 1.3.447 1.51 1.105l2.46 7.69a2.948 2.948 0 002.81 2.056h6.06a2.96 2.96 0 002.781-1.95l1.13-3.131a2.954 2.954 0 00-2.782-3.954H11.663z" />
        <Circle cx={15.473} cy={17.193} r={1.49} />
        <Circle cx={21.653} cy={17.193} r={1.49} />
      </G>
    </Svg>
  )
}

IconCart.dimensions = {
  width: 26,
  height: 23,
}

export default IconCart
